"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentArgs = exports.availableSizes = exports.sizes = void 0;
var sizes = Object.freeze({
  INHERIT: "inherit",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  EXTRA_LARGE: "extra-large"
});
exports.sizes = sizes;
var availableSizes = Object.freeze(Object.values(sizes));
exports.availableSizes = availableSizes;
var componentArgs = {
  fontSize: {
    defaultValue: sizes.INHERIT,
    description: "Icon size",
    control: {
      type: "select"
    },
    options: availableSizes,
    table: {
      type: {
        summary: availableSizes
      },
      defaultValue: {
        summary: sizes.INHERIT
      }
    }
  }
};
exports.componentArgs = componentArgs;